import Input, { InputProps } from '../internal/input';

export type TextInputProps = InputProps;

export default Input;
